module.exports = __webpack_public_path__ + "media/fonts/BasisGrotesquePro-Black-5acbeec44e8d5145177a1ca942b119c8.woff";